import * as React from 'react';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { CURRENT_ENV_ROLE_TYPE } from '../../utils/EnvConfigUtils';

const MAP_GALLERY_PIN_TEARDROP_PATH =
	'M13.5 0C6.044 0 0 6.044 0 13.5c0 10.125 13.5 27.5 13.5 27.5S27 23.625 27 13.5C27 6.044 20.956 0 13.5 0z';

const MAP_GALLERY_PIN_WIDTH = 20;
const MAP_GALLERY_PIN_HEIGHT = 30;

const CIRCLE_CX = 13.5;
const CIRCLE_CY = 13.5;
const CIRCLE_R = 4.781;

export function MapGalleryPin(): React.ReactElement {
	const isSupplier = CURRENT_ENV_ROLE_TYPE === ROLE_TYPES.SUPPLIER;
	const colorClass = isSupplier ? 'text-supplier' : 'text-buyer';
	return (
		<div className={'flex cursor-pointer items-end justify-center ' + colorClass}>
			<svg
				width={MAP_GALLERY_PIN_WIDTH}
				height={MAP_GALLERY_PIN_HEIGHT}
				viewBox="0 0 27 41"
				aria-hidden={true}
			>
				<path
					fill="currentColor"
					stroke="white"
					strokeWidth={2}
					d={MAP_GALLERY_PIN_TEARDROP_PATH}
				/>
				<circle cx={CIRCLE_CX} cy={CIRCLE_CY} r={CIRCLE_R} fill="white" />
			</svg>
		</div>
	);
}
